import { Component, OnInit, signal } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Internship } from './../../models/internship'; // aggiorna il path se necessario
import { CompanyService } from '../../service/company.service';
import { ConfirmationnDialogComponent } from '../confirmation-dialog/confirmation-dialog.component';
import { AlertService } from '../../service/alert.service';
import { FormsModule, NgForm, ReactiveFormsModule } from '@angular/forms';
import { CountryDto } from '../../models/company.model';
import { MatIcon } from "@angular/material/icon";
import { CommonModule } from '@angular/common';
import { MatExpansionPanel, MatAccordion, MatExpansionPanelTitle, MatExpansionPanelHeader } from "@angular/material/expansion";
import { AlertMessageComponent } from "../../shared/alert-message/alert-message.component";
import { MatButtonModule } from "@angular/material/button";
import { TranslateModule, TranslateService } from '@ngx-translate/core';


@Component({
  selector: 'app-add-internship-dialog',
  standalone: true,
  templateUrl: './add-internship-dialog.component.html',
  styleUrl: './add-internship-dialog.component.css',
  imports: [
    MatIcon,
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    MatExpansionPanel,
    AlertMessageComponent,
    MatAccordion,
    MatExpansionPanelTitle,
    MatExpansionPanelHeader,
    MatButtonModule,
    TranslateModule
  ]
})
export class AddInternshipDialogComponent implements OnInit {

  constructor(private dialogRef: MatDialogRef<AddInternshipDialogComponent>,
     private companyService: CompanyService, private dialog: MatDialog,
      private alertService: AlertService, private translate: TranslateService) {}
      
  availableInternships: any[] = [];
  selectedCountry: CountryDto | null = null;


  internshipData: Internship = {
  traineeName: '',
  traineeLastname: '',
  traineeEmail: '',
  availableInternshipTitle: '',
  availableInternshipPosition: '',
  availableInternshipDepartment: '',
  availableInternshipCountry: undefined,
  availableInternshipCity: undefined,
  startDate: '',
  endDate: '',
  status: '',
  supervisorFirstname: '',
  supervisorLastname: '',
  supervisorEmail: '',
  questionnaireCompiled: false
};


ngOnInit(): void {
  this.loadAvailableInternships();
}

loadAvailableInternships() {
  this.companyService.getAvailableInternships().subscribe({
    next: (res) => {
      this.availableInternships = res;
      console.log(this.availableInternships)
    },
    error: (err) => {
      console.error('Errore nel recupero tirocini disponibili', err);
    }
  });
}

onInternshipSelected(event: any) {
  const selectedId = +event.target.value; // converti in numero
  const selectedInternship = this.availableInternships.find(i => i.id === selectedId);
  if (selectedInternship) {
    this.internshipData.availableInternshipTitle = selectedInternship.title;
    this.internshipData.availableInternshipPosition = selectedInternship.position;
    this.internshipData.availableInternshipDepartment = selectedInternship.department;
    this.internshipData.availableInternshipCountry = selectedInternship.country;
    this.internshipData.availableInternshipCity = selectedInternship.city;
    this.selectedCountry = selectedInternship.country ?? selectedInternship.city?.country ?? null;
  }
}

  onCancel(): void {
    this.dialogRef.close();
  }

  saveInternship(form: NgForm, availableInternshipId: any) {

    // Strong validation - prevent any bypass
    if (!this.isFormComplete()) {
      this.alertService.errorKey('internship-dialog.errors.required-fields');
      return;
    }

    if (!form.valid || !availableInternshipId) {
      this.alertService.errorKey('internship-dialog.errors.required-fields');
      return;
    }

    if (!this.internshipData.traineeName || !this.internshipData.traineeLastname || !this.internshipData.traineeEmail) {
      this.alertService.errorKey('internship-dialog.errors.trainee-required');
      return;
    }

    if (!this.internshipData.supervisorFirstname || !this.internshipData.supervisorLastname || !this.internshipData.supervisorEmail) {
      this.alertService.errorKey('internship-dialog.errors.supervisor-required');
      return;
    }

    if (!form.value.startDate) {
      this.alertService.errorKey('internship-dialog.errors.start-date-required');
      return;
    }

    console.log(availableInternshipId);
    if (!form.value.endDate) {
      this.alertService.errorKey('internship-dialog.errors.end-date-required');
      return;
    }
    const today = new Date();

    if(form.value.startDate < today){
      this.alertService.errorKey('internship-dialog.errors.start-date-future');
      return;
    }

    const endDate = new Date(form.value.endDate);
    console.log(endDate)

    // Messaggio da mostrare nel dialog di conferma
    /* let message = "Sei sicuro di voler aggiungere un nuovo tirocinio?"; */

    // Se la data di fine tirocinio è oggi o nel passato, aggiorna lo stato e aggiungi info al messaggio
    /* if (endDate <= today) {
      this.internshipData.status = 'Completed';
      message = "Hai inserito una data di fine tirocinio uguale o precedente a oggi.\n" +
                "Lo stato sarà impostato automaticamente su 'Completed'.\n" +
                "Vuoi procedere con il salvataggio del tirocinio?";
    } */

    // Apri un solo dialog di conferma
    const dialogRef = this.dialog.open(ConfirmationnDialogComponent, {
      width: '400px',
      data: { message: this.translate.instant('internship-dialog.confirm-add') }
    });

    dialogRef.afterClosed().subscribe(result => {
      if (result && this.internshipData) {
        this.companyService.saveInternship(availableInternshipId, this.internshipData).subscribe({
          next: (msg) => {
            this.alertService.success(msg);
            this.dialogRef.close();
            window.location.reload();
          },
          error: (err) => {
            console.log(err);
            this.alertService.error(err.error);
          }
        });
      }
    });
  }

// Metodo separato per aprire il dialog di conferma standard e salvare
/* private confirmAndSave() {
  const dialogRef = this.dialog.open(ConfirmationnDialogComponent, {
    width: '400px',
    data: { message: 'Sei sicuro di voler aggiungere il nuovo tirocinio?' }
  });

  dialogRef.afterClosed().subscribe(result => {
    if (result && this.internshipData) {
      this.companyService.saveInternship(this.internshipData).subscribe({
        next: (msg) => {
          this.alertService.success(msg);
          this.dialogRef.close();
          window.location.reload();
        },
        error: (err) => {
          console.log(err.error);
          this.alertService.error(err.error);
        }
      });
    }
  });
} */


  step = signal(0);

  setStep(index: number) {
    this.step.set(index);
  }

  nextStep() {
    this.step.update(i => i + 1);
  }

  prevStep() {
    this.step.update(i => i - 1);
  }

  isFormComplete(): boolean {
    return !!this.internshipData.id &&
           !!this.selectedCountry &&
           !!this.internshipData.availableInternshipCity &&
           !!this.internshipData.traineeName &&
           !!this.internshipData.traineeLastname &&
           !!this.internshipData.traineeEmail &&
           !!this.internshipData.supervisorFirstname &&
           !!this.internshipData.supervisorLastname &&
           !!this.internshipData.supervisorEmail;
  }

}
